import { type ReactNode, useMemo } from 'react';

import { useLocation } from 'react-router';

import { StatusContext, Statuses } from '@/contexts/Status/StatusContext';
import useSystemStatusRequest from '@/hooks/requests/useSystemStatus.request';

import OutageMessage from '@/components/templates/common/OutageMessage/OutageMessage';
import Loading from '@/components/molecules/Loading';

const backlist = ['support', 'login'];

export function StatusProvider({ children }: { children: ReactNode }) {
  const location = useLocation();
  const [, , rootPage] = location.pathname.split('/');
  const enabled = !backlist.includes(rootPage);
  const queryParams = useSystemStatusRequest({ enabled });

  const { data } = queryParams;

  const value = useMemo(
    () => ({
      status: !data
        ? Statuses.pending
        : data?.status === 'ok'
          ? Statuses.ok
          : Statuses.maintenance,
    }),
    [data]
  );

  if (enabled && value.status === Statuses.pending) {
    return <Loading />;
  }

  if (enabled && value.status === Statuses.maintenance) {
    return <OutageMessage />;
  }

  return <StatusContext value={value}>{children}</StatusContext>;
}
